/**
 * Block is used on
 *
 * @returns {{init(): void, canShowMore: boolean, changeCategory(): void, load(): void, pagesMax: number, showMore(): void, page: number, term_id: number, loading: boolean, posts: []}}
 */
export default () => ({
    posts: [],
    loading: true,
    page: 1,
    pagesMax: 0,
    canShowMore: false,
    term_id: 0,
    searchQuery: '',

    init() {
        let urlTermId = (new URLSearchParams(window.location.search).get('category') || 0);

        if (urlTermId > 0)
            this.term_id = urlTermId;

        this.load();
    },

    clear() {
        this.searchQuery = '';
        this.search();
    },

    search() {
        this.page = 1;
        this.loading = true;
        this.posts = [];
        this.load();
    },

    load() {
        let ref = this;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_fetch_posts&term_id=' + this.term_id + '&query=' + this.searchQuery,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                data.data.results.forEach(function (p, index) {
                    ref.posts.push({
                        'id': p.id,
                        'title': p.title,
                        'permalink': p.permalink,
                        'excerpt': p.excerpt,
                        'image': p.image,
                        'date_short': p.date_short,
                        'date_formatted': p.date_formatted
                    });
                });

                this.loading = false;
                this.page++;
                this.pagesMax = data.data.max_num_pages
                this.canShowMore = (this.pagesMax >= this.page);
            })
            .catch((error) => {
                console.error(error);
            });
    },

    changeCategory() {
        this.loading = true;
        this.posts = [];
        this.load();
    },

    showMore() {
        let ref = this;
        this.loading = true;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_fetch_posts&page=' + this.page + '&term_id=' + this.term_id
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                data.data.results.forEach(function (p, index) {
                    ref.posts.push({
                        'id': p.id,
                        'title': p.title,
                        'permalink': p.permalink,
                        'excerpt': p.excerpt,
                        'image': p.image,
                        'date_short': p.date_short,
                        'date_formatted': p.date_formatted
                    });
                });

                this.loading = false;
                this.page++;
                this.pagesMax = data.data.max_num_pages
                this.canShowMore = (this.pagesMax >= this.page);

                let scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;

                window.scrollTo({
                    top: scrollPos + 400,
                    behavior: 'smooth'
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }
})